import { Box, Grid } from "@mui/material";
import fitness1 from "../../assets/images/facilities/fitness/fitness1.jpg";
import fitness2 from "../../assets/images/facilities/fitness/fitness2.jpg";
import fitness3 from "../../assets/images/facilities/fitness/fitness3.jpg";
import fitness4 from "../../assets/images/facilities/fitness/fitness4.jpg";
import fitness5 from "../../assets/images/facilities/fitness/fitness5.jpg";

const images = [
  { src: fitness1, alt: "Fitness Image 1" },
  { src: fitness2, alt: "Fitness Image 2" },
  { src: fitness3, alt: "Fitness Image 3" },
  { src: fitness4, alt: "Fitness Image 4" },
  { src: fitness5, alt: "Fitness Image 5" },
  // Add more images as needed
];

const FitnessGallery = () => (
  <Grid container spacing={2}>
    {images.map((image, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Box component="img" src={image.src} alt={image.alt} width="80%" m={2} />
      </Grid>
    ))}
  </Grid>
);

const Fitness = () => (
  <div>
    <FitnessGallery />
  </div>
);

export default Fitness;
